import React from "react";
import "../styles/CasosExito.scss";

export const CasosExito = () => {
  return (
    <div className="containerCasosExito d-flex justify-content-start align-items-center flex-column">
    <div className="d-flex justify-content-center align-items-center flex-column titleCasosExito text-center">
      <br/><span className="titleCasos mt-4">
        Cientos de personas nos recomiendan
      </span>
      <span className="subtitleCasos">
      Descubre cómo empresas y hogares han mejorado la limpieza de sus espacios con nuestros servicios. Historias reales de clientes que confiaron en nosotros y ahora disfrutan de ambientes más limpios y saludables.<br/><br/>¡Ellos ya alcanzaron la calidad que buscaban, y tú también puedes lograrlo!
      </span>
    </div>
    <div className="resenasContainerManin mt-5 mb-5">
        <div className="resena" id="resena1">
            <span className="titleResena mt-3">Ana Rodríguez</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
              Contratar este servicio de limpieza fue una excelente decisión para nuestra oficina. La limpieza final tras nuestra remodelación dejó todo impecable. Los resultados fueron más allá de nuestras expectativas, el equipo fue muy profesional y eficiente. Definitivamente volveremos a contratarlos.
              </span>
            </div>
        </div>
        <div className="resena" id="resena2">
            <span className="titleResena mt-3">Carlos Mendoza</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
              Estoy muy satisfecho con el trabajo realizado en mi hogar después de una inundación. El equipo de limpieza hizo un trabajo increíble, eliminando todo el daño y dejándonos con un ambiente limpio y seguro. Su atención al detalle y profesionalismo nos dio mucha tranquilidad.
              </span>
            </div>
        </div>
        <div className="resena" id="resena3">
            <span className="titleResena mt-3">Laura Sánchez</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
              El servicio de desengrasado de nuestra cocina industrial superó nuestras expectativas. El equipo fue rápido, eficiente y muy profesional. El resultado fue una cocina mucho más limpia y libre de grasa, lo que mejoró tanto la seguridad como la productividad en nuestro negocio.
              </span>
            </div>
        </div>
    </div>
  </div>
  
  );
};

export default CasosExito;
